import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { tap } from 'rxjs/operators';

import { ApiUsersService } from '../services';
import { SnackbarService } from '@fitscovery/ui/snackbar';

import { UsersActions } from '../actions';
import { User, UserResponse } from '../models';
import { UsersStateModel } from '../types';
import { UserControlState } from './user-control-state';

const usersStateDefaults: UsersStateModel = {
  users: [],
  user: null,
};

export const USERS_STATE_TOKEN = new StateToken<UsersStateModel>('users');

@State<UsersStateModel>({
  name: USERS_STATE_TOKEN,
  defaults: usersStateDefaults,
})
@Injectable()

export class UsersState extends UserControlState implements NgxsOnInit {

  @Selector()
  static users(state: UsersStateModel): User[] {
    return state.users;
  }

  constructor(
    private usersService: ApiUsersService,
    public override snackbar: SnackbarService
  ) {
    super(snackbar);
  }

  ngxsOnInit(): void {
  }

  @Action(UsersActions.AddUser)
  addUser(ctx: StateContext<UsersStateModel>, action: UsersActions.AddUser) {
    return this.usersService.createUser(action.payload).pipe(
      this.catchResponse
    );
  }

  @Action(UsersActions.GetUsers)
  getUsers(ctx: StateContext<UsersStateModel>) {
    return this.usersService.getUsers().pipe(
      tap((response: UserResponse) => ctx.patchState({ users: response.data })),
      this.catchResponse
    );
  }

  @Action(UsersActions.GetUserByEmail)
  getUser(ctx: StateContext<UsersStateModel>, action: UsersActions.GetUserByEmail) {
    return this.usersService.getUserByEmail(action.email).pipe(
      tap((response: UserResponse) => ctx.patchState({ user: response.data[0] })),
      this.catchResponse
    );
  }

  @Action(UsersActions.DeleteUserRole)
  deleteUser(ctx: StateContext<UsersStateModel>, action: UsersActions.DeleteUserRole) {
    return this.usersService.deleteUser(action.id).pipe(
      this.catchResponse
    );
  }

}
